/**
 * This method splits a string by a delimiter only on the first 'n' occurrences
 * @example splitOnN("Something : Else : And : More", " : ", 2) => ["Something","Else","And : More"]
 * @param {String} str the string to be splitted
 * @param {String} delimiter the split string
 * @param {Number} n the 'n' occurrences of the delimiter
 * @returns
 */
export function splitOnN(str, delimiter, n) {
  // if n is equal or lower than zero, just return an array with the string
  if (n <= 0) {
    return [str];
  }
  // split it in parts
  const parts = str.split(delimiter);

  // these are the parts i want splitted
  const firstParts = parts.slice(0, n);

  // this is the rest that i want not to be splitted, so i rejoin them
  const remainingParts = parts.slice(n).join(delimiter);

  // remainingParts may be an an empty string if there is a comma at the end
  return remainingParts ? firstParts.concat([remainingParts]) : firstParts;
}
